localStorage.setItem("notCustomerId","");
$(".btns--low-points .lowPoints").click(function (e) {
localStorage.setItem("lowPoints","true");
});
let orderData = {
    "result": {
        "billingAddress": {
            "firstName": "Pradeep",
            "lastName": "singh",
            "email": "fabprojectmanager@gmail.com",
            "address": "",
            "apartment": "",
            "city": "",
            "country": "US",
            "state": "Alabama"
        },
        "cartNote": "",
        "cartItems": [
            {
                "productTitle": "Better Than A Text",
                "variant_id": 40768971636841,
                "productUrlGet": "/products/better-than-a-text",
                "productPrice": "1.20",
                "productUrl": "https://simplynoted.com/collections/best-sellers/products/better-than-a-text",
                "qyt": 1,
                "proImage": "//simplynoted.com/cdn/shop/products/Better.Than.A.Text_copy_1024x1024.jpg?v=1650639062",
                "properties": {
                    "bulk_address": "\n  \n  \n",
                    "selectedText": "Single Card",
                    "font_family": "astTracy",
                    "custom_message": "sgE",
                    "font_size": "60px",
                    "font_size_cust_card": "60px",
                    "line_ht_cust_card": "60px",
                    "signoff": "",
                    "custom_font": "",
                    "font_selection": "Tarzan",
                    "recipient_upload": "Not Applicable",
                    "ship_date": "",
                    "sender_fullName": "jkv kjb",
                    "sender_address1": "hjbhjb",
                    "sender_address2": "kjujfvh ",
                    "sender_city": "kbhjb",
                    "sender_state": "Arkansas",
                    "sender_zip": "878779",
                    "sender_country": "US",
                    "sender_id": "6524f6468389a8f022f022a3",
                    "gift_card_ID": 1697029705842,
                    "uqId": 1697029705842,
                    "gift_id": null,
                    "recipient_id": "6524e56d8389a8f022f01ee2",
                    "recipient_fullName": "Fel 4",
                    "recipient_businessName": "",
                    "recipient_address1": "499 X",
                    "recipient_address2": "",
                    "recipient_city": "Santa Rosa",
                    "recipient_state": "CA",
                    "recipient_zip": "94200",
                    "recipient_country": "USA"
                },
                "additionalProducts": {
                    "postageUS": {
                        "id": 40677547769961,
                        "url": "/products/postage",
                        "qyt": 1
                    },
                    "giftCard": {
                        "id": "39532031672425",
                        "url": "/products/amazon-gift-card-new",
                        "qyt": 1
                    }
                }
            },
            {
                "productTitle": "Cactus Thank you",
                "variant_id": 40768973766761,
                "productUrlGet": "/products/cactus-thank-you",
                "productPrice": "1.20",
                "productUrl": "https://simplynoted.com/collections/best-sellers/products/cactus-thank-you",
                "qyt": 1,
                "proImage": "//simplynoted.com/cdn/shop/products/Cactus-Thank-You_1024x1024.jpg?v=1650634460",
                "properties": {
                    "bulk_address": "\n  \n  \n",
                    "selectedText": "Single Card",
                    "font_family": "astTracy",
                    "custom_message": "SDFSDFDFDF",
                    "font_size": "60px",
                    "font_size_cust_card": "60px",
                    "line_ht_cust_card": "60px",
                    "signoff": "",
                    "custom_font": "",
                    "font_selection": "Tarzan",
                    "recipient_upload": "Not Applicable",
                    "ship_date": "",
                    "sender_fullName": "jkv kjb",
                    "sender_address1": "hjbhjb",
                    "sender_address2": "kjujfvh ",
                    "sender_city": "kbhjb",
                    "sender_state": "Arkansas",
                    "sender_zip": "878779",
                    "sender_country": "US",
                    "sender_id": "6524f6468389a8f022f022a3",
                    "gift_card_ID": 1697029753136,
                    "uqId": 1697029753136,
                    "gift_id": "39532033146985",
                    "recipient_id": "6524e56d8389a8f022f01ee2",
                    "recipient_fullName": "Fel 4",
                    "recipient_businessName": "",
                    "recipient_address1": "499 X",
                    "recipient_address2": "",
                    "recipient_city": "Santa Rosa",
                    "recipient_state": "CA",
                    "recipient_zip": "94200",
                    "recipient_country": "USA"
                },
                "additionalProducts": {
                    "postageUS": {
                        "id": 40677547769961,
                        "url": "/products/postage",
                        "qyt": 1
                    },
                    "giftCard": {
                        "id": "39532033146985",
                        "url": "/products/visa-gift-card_new",
                        "qyt": 1
                    }
                }
            }
        ],
        "cartTotal": 46.62,
        "wallet": true,
        "order_number": 33358,
        "order_financial_status": "paid",
        "orderId": 5494050586729
    },
    "errors": []
};
$("#order-num span").text("#" + orderData.result.order_number);
$("#order-total span").text(formatter.format(orderData.result.cartTotal))
$("#order-email span").text(orderData.result.billingAddress.email)

async function processOrderData(product,e,index,reverseIndex) {
   let htmlContent = `<table>
  <thead>
<tr>
<th>
Item Name
</th>
<th>
  Item Total
</th></tr>
</thead>
<tbody>` + 
product;
      // Gift Card
      if (e?.additionalProducts?.giftCard) {
        let id = e.additionalProducts.giftCard.id,
          qyt = e.additionalProducts.giftCard.qyt;

        try {
          const giftCardData = await $.getJSON(`${e.additionalProducts.giftCard.url}.js`);
          const giftCard = giftCardData.variants.find(e => e.id == id);
          if (giftCard) {
            htmlContent += `
<tr>
  <td>
    <div>
      ${giftCardData.title} <span>${e.qyt}</span>
      
    </div>
  </td>
<td>
<span>${formatter.format(giftCard.price / 100)}</span>
</td></tr>
`;
          }
        } catch (error) {
          console.error("Error fetching gift card data", error);
        }
      }
      // Postage US
      if (e?.additionalProducts?.postageUS) {
        let id = e.additionalProducts.postageUS.id,
          qyt = e.additionalProducts.postageUS.qyt;

        try {
          const giftCardData = await $.getJSON(`${e.additionalProducts.postageUS.url}.js`);
          const giftCard = giftCardData.variants.find(e => e.id == id);
          if (giftCard) {
            htmlContent += `
<tr>
  <td>
    <div>
      ${giftCardData.title} <span>${e.qyt}</span>
      
    </div>
  </td>
<td>
<span>${formatter.format(giftCard.price / 100)}</span>
</td></tr>
`;
          }
        } catch (error) {
          console.error("Error fetching gift card data", error);
        }
      }
      // Postage Non US
      if (e?.additionalProducts?.postageNonUS) {
        let id = e.additionalProducts.postageNonUS.id,
          qyt = e.additionalProducts.postageNonUS.qyt;

        try {
          const giftCardData = await $.getJSON(`${e.additionalProducts.postageNonUS.url}.js`);
          const giftCard = giftCardData.variants.find(e => e.id == id);
          if (giftCard) {
                     htmlContent += `
<tr>
  <td>
    <div>
      ${giftCardData.title} <span>${e.qyt}</span>
      
    </div>
  </td>
<td>
<span>${formatter.format(giftCard.price / 100)}</span>
</td></tr>
`;
          }
          
        } catch (error) {
          console.error("Error fetching gift card data", error);
        }
      }
      // Shipping
      if (e?.additionalProducts?.shipping) {
        let id = e.additionalProducts.shipping.id,
          qyt = e.additionalProducts.shipping.qyt;

        try {
          const giftCardData = await $.getJSON(`${e.additionalProducts.shipping.url}.js`);
          const giftCard = giftCardData.variants.find(e => e.id == id);
          if (giftCard) {
               htmlContent += `
<tr>
  <td>
    <div>
      ${giftCardData.title} <span>${e.qyt}</span>
      
    </div>
  </td>
<td>
<span>${formatter.format(giftCard.price / 100)}</span>
</td></tr>
`;
          }
        } catch (error) {
          console.error("Error fetching shipping data", error);
        }
      }

htmlContent += `</tbody>
    <tfoot>
    <tr>
      <td>SUBTOTAL</td>
      <td class="product-total"></td>
    </tr>
  </tfoot>
</table>`;
           $(".order-product-items").prepend(htmlContent);
}

  orderData.result.cartItems.forEach(function (e, index) {
 const reverseIndex = orderData.result.cartItems.length - 1 - index;
$.getJSON(`${e.productUrlGet}.js`, function(product) {
     return product;
    }).then(function (pro) {
    let product = `<tr>
  <td>
    <div>
      <a href="${e.productUrlGet}">${pro.title}</a> <span>${e.qyt}</span>
      
    </div>
  </td>
<td>
<span>${formatter.format(e.productPrice)}</span>
</td></tr><tr>
  <td>
    <div>
      Postage Non-US <span>${e.qyt}</span>
      
    </div>
  </td>
<td>
<span>$1.50</span>
</td></tr>
`;
processOrderData(product,e,index,reverseIndex);
            });


       });







var mainUrl = "https://api.simplynoted.com/stripe/";
function con_state(state, country) {
  var user_country_code = "US";

  (() => {
    const country_array = country_and_states.country;
    const states_array = country_and_states.states;

    const id_state_option = document.getElementById(state);
    const id_country_option = document.getElementById(country);

    const createCountryNamesDropdown = () => {
      let option = "";
      option += '<option value="">select country</option>';

      for (let country_code in country_array) {
        // set selected option user country
        let selected = country_code == user_country_code ? " selected" : "";
        option += '<option value="' + country_code + '"' + selected + ">" + country_array[country_code] + "</option>";
      }
      id_country_option.innerHTML = option;
    };

    const createStatesNamesDropdown = () => {
      let selected_country_code = id_country_option.value;
      // get state names
      let state_names = states_array[selected_country_code];

      // if invalid country code
      if (!state_names) {
        id_state_option.innerHTML = "<option disabled>select state</option>";
        return;
      }

      let option = "";
      option += "<option disabled>select state</option>";
      for (let i = 0; i < state_names.length; i++) {
        option += '<option value="' + state_names[i].name + '">' + state_names[i].name + "</option>";
      }

      id_state_option.innerHTML = option;
    };

    // country select change event
    id_country_option.addEventListener("change", createStatesNamesDropdown);

    createCountryNamesDropdown();
    createStatesNamesDropdown();
  })();
}
function addParameter(newParam, paramVal) {
  let currentUrl = window.location.href;
  if (currentUrl.includes("?")) {
    currentUrl += `&${newParam}=${paramVal}`;
  } else {
    currentUrl += `?${newParam}=${paramVal}`;
  }
  window.history.replaceState({}, document.title, currentUrl);
}
function removeParameter(paramNameToRemove) {
  let currentUrl = window.location.href;
  const paramToRemove = paramNameToRemove;
  const urlParts = currentUrl.split("?");
  if (urlParts.length > 1) {
    const queryParams = urlParts[1].split("&");
    const updatedParams = [];
    for (const param of queryParams) {
      const [name, value] = param.split("=");
      if (name !== paramToRemove) {
        updatedParams.push(param);
      }
    }
    currentUrl = urlParts[0] + "?" + updatedParams.join("&");
  }
  window.history.replaceState({}, document.title, currentUrl);
}
function getParameter(paramNameToCheck, desiredValue) {
  let currentUrl = window.location.href;
  const urlParts = currentUrl.split("?");
  if (urlParts.length > 1) {
    const queryParams = urlParts[1].split("&");
    for (const param of queryParams) {
      const [name, value] = param.split("=");
      if (name === paramNameToCheck && value === desiredValue) {
        return true;
      }
    }
  }
}

// con_state("state__", "country__");

con_state("state-", "country-");
$(document).ready(function () {
  $(".cards_grid_item_preview_close").click(function () {
    $(".payment_cards_grid_item_preview").removeClass("active");
    $(".popup-inner").removeClass("open_popup_inner");
    $(".payment_cards_grid_item_preview").delay(300).fadeOut();
    $(".cards_grid_item_preview-wrapper-all").html(" ");
  });
});

const cheking = getParameter("billing", "true");
if (cheking == true) {
  $(".payment_card_main").hide();
  $(".billing_order_summary_main").show();
}

$(".proceed_to_checkoutbtn").click(function () {
  addParameter("billing", "true");
  $(".payment_card_main").hide();
  $(".billing_order_summary_main").show();
  window.scrollTo({ top: 0, behavior: "smooth" });
$.ajax({
  url: "https://api.simplynoted.com/stripe/customer-data?customerId=" + customerIdS,
  method: 'GET',
  success: function(respo) {
if(respo.stripe?.manual == true){
$("#customer--account-credits-point").text(formatter.format(respo.stripe.balance));
}
else{
if(respo.stripe.packageDiscount != 0 && respo.stripe.subscription != "undefined" ||  respo.stripe.subscription != undefined){
if(respo.stripe.balance > 0){
$("#customer--account-credits-point").text(formatter.format(respo.stripe.balance));
}
    else{
      $("#customer--account-credits-point").text("$0.00");
    }
}
  }
  },
  error: function(error) {
$(".paymentMethodwalletWrapper").addClass("not-wallet-customer");
$("#card-element-").addClass("show");
$("#CreditCard").trigger("click");
}
});
});
$(".go_backto_cart").click(function () {
  window.scrollTo({ top: 0, behavior: "smooth" });
  removeParameter("billing");
  $(".payment_card_main").show();
  $(".billing_order_summary_main").hide();
});

// Add Credit Card
$(".add_credit-card").click(function () {
  $(".credit-card-form,.payment-gateway").show();
});

$(window).on("load", function () {
  const stripeee = Stripe("pk_live_51NWJuCKwXDGuBPYACTmf4whQke6gj77EyaKRvNgEwQ6TtajZ2WV5mqId0CJVv681JbA5OAoW58UBua1nyYCOKjCf00PsVowSiN");
  const elementss = stripeee.elements();
  const style = {
    base: {
      fontSize: "20px",
      height: "40px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
    },
  };
  const cardElementt = elementss.create("card", { style });
  cardElementt.mount("#card-element-add-multiple");

  const form = document.getElementById("multiple-card-form");
  form.addEventListener("submit", async (event) => {


    $("error-update-card").hide();
    event.preventDefault();
    const formData = new FormData(form);
    stripeee.createPaymentMethod({
      type: "card",
      card: cardElementt,
    }).then(function (result) {
      if (result.error) {
        console.log("result error", result);
        $("#error-update-card").text(`Error: ${result.error.message}`);
        $("#error-update-card").show();
    $(".csv-upload").hide();
    $(".credit-card-form").show();
      } else {
    // $(".csv-upload").fadeIn();
    // $(".credit-card-form").fadeOut();
        const paymentMethod = result.paymentMethod;
        const paymentMethodId = paymentMethod.id;
        $.ajax({
          url: mainUrl + "add-new-payment-method?customerId=" + customerId,
          method: "POST",
          data: {
            paymentMethodId: paymentMethodId,
          },
          success: function (updatedCard) {  $("#error-update-card").hide();
            $(".csv-upload .loader-wrapper + h2").hide();
            $(".csv-upload .loader-payemnt")
              .show()
              .addClass("loader-payemnt-active");
            setTimeout(function () {
              $(".csv-upload").fadeOut();
              $(".csv-upload .loader-payemnt")
                .show()
                .removeClass("loader-payemnt-active");
              const customerIdS = localStorage.getItem("snCustomerId");

              $.ajax({
                url:
                  "https://api.simplynoted.com/stripe/customer-data?customerId=" + customerId,
                method: "GET",
                success: function (respo) {
                  $(".exsiting-cards").html(" ");
                  respo.payments.forEach(function (e, index) {
                    location.reload()
                    let payment = `<div class="card-element-filled"><div>
<input type="radio" id="id-${index}" name="payment" value="${e.paymentId}" checked> <label  for="id-${index}"></label>
</div><div><span>**** **** **** ${e.cardLast4Number}</span><span>${e.cardExpMonth} / ${e.cardExpYear}</span></div></div>`;
                    $(".exsiting-cards").prepend(payment);
                  });
                },
              });
            }, 3000);
            console.log("updated card >", updatedCard);
          },
          error: function (updatedCardError) {
    $(".csv-upload").hide();
    $(".credit-card-form").show();
const obj = JSON.parse(updatedCardError.responseText);
   $("#error-update-card").text("Error: " + obj.raw.message);
            $("#error-update-card").show();
            console.log("Update Card Error:", updatedCardError.responseText);
          },
        });
      }
    }).catch(function (error) {
    $(".csv-upload").hide();
    $(".credit-card-form").show();
      $("error-update-card").text("Something went wrong. Try again later!");
      $("error-update-card").show();
      console.log("error", error);
    });
  });
});
$(window).on("load", function () {
  const stripeee = Stripe("pk_live_51NWJuCKwXDGuBPYACTmf4whQke6gj77EyaKRvNgEwQ6TtajZ2WV5mqId0CJVv681JbA5OAoW58UBua1nyYCOKjCf00PsVowSiN");
  const elementss = stripeee.elements();
  const style = {
    base: {
      fontSize: "20px",
      height: "40px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
    },
  };
  const cardElementt = elementss.create("card", { style });
  cardElementt.mount("#card-element-add-multiple");

  const form = document.getElementById("multiple-card-form");
  form.addEventListener("submit", async (event) => {
    $("error-update-card").hide();
    event.preventDefault();
    const formData = new FormData(form);
    stripeee.createPaymentMethod({
      type: "card",
      card: cardElementt,
    }).then(function (result) {
      if (result.error) {
        console.log("result error", result);
        $("#error-update-card").text(`Error: ${result.error.message}`);
        $("#error-update-card").show();
      } else {
            $(".csv-upload").fadeIn();
    $(".credit-card-form").fadeOut();
        const paymentMethod = result.paymentMethod;
        const paymentMethodId = paymentMethod.id;
        $.ajax({
          url: mainUrl + "add-new-payment-method?customerId=" + customerId,
          method: "POST",
          data: {
            paymentMethodId: paymentMethodId,
          },
          success: function (updatedCard) {
  $("#error-update-card").hide();
            $(".csv-upload .loader-wrapper + h2").hide();
            $(".csv-upload .loader-payemnt").show().addClass("loader-payemnt-active");
            setTimeout(function () {
              $(".csv-upload").fadeOut();
              $(".csv-upload .loader-payemnt").show().removeClass("loader-payemnt-active");
              const customerIdS = localStorage.getItem("snCustomerId");

              $.ajax({
                url: "https://api.simplynoted.com/stripe/customer-data?customerId=" + customerIdS,
                method: "GET",
                success: function (respo) {
                  $(".exsiting-cards").html(" ");
                  respo.payments.forEach(function (e, index) {
                    let payment = `<div class="card-element-filled"><div>
<input type="radio" id="id-${index}" name="payment" value="${e.paymentId}" checked> <label  for="id-${index}"></label>
</div><div><span>**** **** **** ${e.cardLast4Number}</span><span>${e.cardExpMonth} / ${e.cardExpYear}</span></div></div>`;
                    $(".exsiting-cards").prepend(payment);
                  });
                },
              });
            }, 3000);
            console.log("updated card >", updatedCard);
          },
          error: function (updatedCardError) {
   $(".csv-upload").hide();
    $(".credit-card-form").show();
const obj = JSON.parse(updatedCardError.responseText)
            $("#error-update-card").text("Error: " + obj.raw.message);
            $("#error-update-card").show();
            console.log("Update Card Error:", updatedCardError);
          },
        });
      }
    }).catch(function (error) {
      $("error-update-card").text("Something went wrong. Try again later!");
      $("error-update-card").show();
      console.log("error", error);
    });
  });
});
$(".close-btn").click(function () {
  $(this).parents(".popup-section").delay(300).fadeOut();
});

// Low points

$(".btns--low-points + p").hide();
$(".btns--low-points a+ a").click(function () {
  $(".point-low-popup").fadeOut();
  $(".order_summary_purchase_btn").addClass("continue-active");
  $("#CreditCard").trigger("click");
  $(".paymentMethodCCWrapper").addClass("active");
});

function onCartPurchase(_this){
      if (
    (localStorage.getItem("packageBalance") <
      $(".grand_total_price p").data("price") &&
      $("body").hasClass("loggedin") &&
      $(".paymentMethodwalletWrapper").hasClass("active")) ||
    (localStorage.getItem("packageBalance") < 100 && $(".paymentMethodwalletWrapper").hasClass("active") &&
      !_this.hasClass("continue-active"))
  ) {
    if (localStorage.getItem("packageBalance") < 100) {
      $(".btns--low-points a+ a").show();
    } else {

      $(".btns--low-points + p").hide();
    }
    $(".point-low-popup").fadeIn();
  } 
    else {
_this.attr("disabled",true);
    let billingAddress = {
      firstName: $('.cart-payment [name="FirstName"]').val(),
      lastName: $('.cart-payment [name="LastName"]').val(),
      email: $('.cart-payment [name="Email"]').val(),
      address: $('.cart-payment [name="Address"]').val(),
      apartment: $('.cart-payment [name="Apartment"]').val(),
      city: $('.cart-payment [name="city"]').val(),
      country: $('.cart-payment [name="Country"]').val(),
      state: $('.cart-payment [name="State"]').val(),
    };
    let gettingData = localStorage.getItem("cartData");
    let data = JSON.parse(gettingData);

    let orderData = {
      billingAddress: billingAddress,
      cartNote: $("#cart-note").val() ? $("#cart-note").val() : "",
      cartItems: data,
      cartTotal: $(".grand_total_price p").data("price"),
      discountCode: $('#Discount').val(),
      discountValueType:$('#Discount').attr('data-type'),
      discountValue:$('#Discount').attr('data-discounted-amount')
    };

    let checkedInputs = $(".card-element-filled input:checked");
    if (
      checkedInputs.length > 0 &&
      $(".paymentMethodCCWrapper").hasClass("active")
    ) {
      orderData.paymentMethodKey = checkedInputs.val();
    }
    if ($(".paymentMethodwalletWrapper").hasClass("active")) {
      orderData.wallet = true;
    }

    console.log(">>> ", orderData);
    const customerId = localStorage.getItem("snCustomerId");
    const authToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI2NDNiYjVhOTAwODcwZjFmMjQ3OGRjNjkiLCJ1c2VyIjp7ImVtYWlsIjoiZmFicHJvamVjdG1hbmFnZXJAZ21haWwuY29tIiwic2hvcGlmeUlkIjoiNjIzMjYyMjg5MTExMyIsIl9pZCI6IjY0M2JiNWE5MDA4NzBmMWYyNDc4ZGM2OSIsImZpcnN0X25hbWUiOiJQcmFkZWVwIiwibGFzdF9uYW1lIjoic2luZ2gifSwiaWF0IjoxNjkwNDQwNDY0fQ.5s5g9A2PtZ8Dr5dQZsd0D9wWTT2BzDioqDXzTbIJPko";
        $.ajax({
          method: "POST",
          cors: true,
          headers: {
            "Content-Type": "application/json"
          },
          url: "https://api.simplynoted.com/api/storefront/wallet-order?customerId=" + customerId,
          data: JSON.stringify(orderData)
        }).done(function( data ) { 
console.log(data)
localStorage.setItem("cartData", "[]");
$(".tt-badge-cart").text("0")

$("#thankyou-popup").show();
$('html, body').animate({scrollTop:0}, 'slow');
$(".billing_order_summary_main").hide();
  removeParameter("billing"); 
setTimeout(function(){
$(".csv-upload").fadeOut();

$(".csv-upload .loader-payemnt").show().removeClass("loader-payemnt-active");
$(".csv-upload .loader-wrapper + h2 span").text(oldText);
$(".csv-upload .loader-payemnt h2").text(oldText2);
},5000);

        }).fail(function(err) {
          console.log(err)
$(this).attr("disabled",false);
$(".csv-upload .loader-wrapper + h2 span").text("We’ve encountered an error while processing your order. Please try again later.");
setTimeout(function(){
$(".csv-upload").fadeOut();

},2000);
        }); 
    
  }
}
$(".order_summary_purchase_btn").click(function () {
$(this).attr("disabled","disabled");
$(".order_summary_purchase_btn").text("Processing Order");
if($(".order_summary_purchase_btn").attr("disabled") == "disabled"){

}

// $(".csv-upload").fadeIn();
// $(".csv-upload .loader-wrapper + h2").show();
// $(".csv-upload .loader-wrapper + h2 span").text("Processing Order");
// $(".csv-upload .loader-payemnt h2").text("Order successfully placed");
let id = localStorage.getItem("snCustomerId");
if($("body").hasClass("log-out")){
   id = localStorage.getItem("notCustomerId");
}


let _this = $(this);
$.ajax({
  url: "https://api.simplynoted.com/stripe/customer-data?customerId=" + id,
  method: 'GET',
  success: function(respo) {
if($(".paymentMethodwalletWrapper").hasClass("active")){
  if(respo?.stripe?.balance > 0){
onCartPurchase(_this);
  }
else{
   $(".cart-errors span").text("Please add a Credits.");
   $(".cart-errors").show();  
$(".order_summary_purchase_btn").removeAttr('disabled'); 
$(".order_summary_purchase_btn").text("PURCHASE");
   $('html, body').animate({scrollTop:0}, 'slow');
}
}
    else if($(".paymentMethodCCWrapper").hasClass("active")){
  if($(".exsiting-cards").html() == ""){
 $(".cart-errors span").text("Please add a Credit Card.");
   $(".cart-errors").show();   
   $('html, body').animate({scrollTop:0}, 'slow');
$(".order_summary_purchase_btn").text("PURCHASE");
$(".order_summary_purchase_btn").removeAttr('disabled'); 
}
      else{
         onCartPurchase(_this);
      }
    }
  },
  error:function(error){
$(".order_summary_purchase_btn").text("PURCHASE");
$(".order_summary_purchase_btn").removeAttr('disabled'); 
    if(error?.responseJSON?.error == "Error fetching stripe data"){
$(".cart-errors span").text("Please add a Credit Card.");
   $(".cart-errors").show();   
   $('html, body').animate({scrollTop:0}, 'slow');
    }
    else{
$(".cart-errors span").text("Something went worng! Please try again.");
   $(".cart-errors").show();  
   $('html, body').animate({scrollTop:0}, 'slow');
    }
  }
});


});


$(".accordion-wrapper h3").click(function () {
  $(this).next().slideToggle();
  $(this).toggleClass("active");
});
$(window).on("load",function(){
$("#cart-term-conditions-checkbox").change(function () {
  if ($(this).is(":checked")) {
     $(".proceed_to_checkoutbtn").removeAttr("disabled", "disabled");
  } else {
    $(".proceed_to_checkoutbtn").attr("disabled", "disabled");
  }
});
})



$(".paymentMethodCardWrapper:not(.not-wallet-customer) .paymentMethodCard").click(function () {
  $(this).next().slideDown();
  $(this).parent().siblings().find(".paymentMethodCard + div").slideUp();
  $(this).parent().addClass("active").siblings().removeClass("active");
});

$(".credit-card-form .close-popup").click(function () {
  $(".credit-card-form").hide();
});

$(window).on('load', function() {
    const stripe = Stripe('pk_live_51NWJuCKwXDGuBPYACTmf4whQke6gj77EyaKRvNgEwQ6TtajZ2WV5mqId0CJVv681JbA5OAoW58UBua1nyYCOKjCf00PsVowSiN');
    const elements = stripe.elements();
    const style = {
      base: {
        fontSize: "20px",
        height: "40px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
      },
    };
    const cardElement = elements.create("card", { style });
    cardElement.mount('#card-element-15');

    const form = document.getElementById("payment-form-add");
    form.addEventListener("submit", async (event) => {
$(".pay-now").css("opcaity","0.7");      
$(".pay-now").text("ADDING CARD");
$(".form-loader").fadeIn();
        event.preventDefault();
        const formData = new FormData(form);
        stripe.createPaymentMethod({
          type: "card",
          card: cardElement,
        }).then(function (result) {
          console.log("result >", result)
          if (result.error) {
            console.log("result error", result)
          } else {
            const paymentMethod = result.paymentMethod;
            const paymentMethodId = paymentMethod.id;
      if($("body").hasClass("loggedin")){
    $.ajax({
              url: mainUrl + "create-customer?customerId=" + customerId,
              method: "POST",
              data: {
                paymentMethodId: paymentMethodId,
                email: form.elements["credit-email"].value,
                name: form.elements["credit-name"].value,
                address: {
                  line1: form.elements["credit-address"].value,
                  line2: form.elements["credit-apartment"].value,
                  city: form.elements["credit-city"].value,
                  state: form.elements["credit-state"].value,
                  country: form.elements["credit-country"].value                  
                },
              },
              success: function (customerData) {
                if (customerData.stripeCustomerId) {
                  $(".form-loader").fadeOut();
                  $(".loader-payemnt").addClass("loader-payemnt-active");
                  setTimeout(function () {
                      $(".loader-payemnt").removeClass(
                        "loader-payemnt-active"
                      );
             $.ajax({
                url: "https://api.simplynoted.com/stripe/customer-data?customerId=" + customerId,
                method: "GET",
                success: function (respo) {
$(".pay-now").css("opcaity","1");      
$(".pay-now").text("SAVE");
$(".credit-card-form").hide();
$(".credit-card_input_fields").show();
$("input#saved_credit-card[disabled]+label").css("opcaity","1"); 
$("input#saved_credit-card[disabled]+label").css("pointer-events","auto"); 
$("#payment-form-add").hide();
$("#multiple-card-form").show();
                  $(".exsiting-cards").html(" ");
console.log(respo)
                  respo.payments.forEach(function (e, index) {
                    let payment = `<div class="card-element-filled"><div>
<input type="radio" id="id-${index}" name="payment" value="${e.paymentId}" checked> <label  for="id-${index}"></label>
</div><div><span>**** **** **** ${e.cardLast4Number}</span><span>${e.cardExpMonth} / ${e.cardExpYear}</span></div></div>`;
                    $(".exsiting-cards").prepend(payment);
                  });

                },
              });
                  }, 3500);
                }
              },
              error: function (customerError) {
                console.log("Customer Error:", customerError);
$(".error-update-card-0").show();
                $(".error-update-card-0").text("Error:",customerError.error.message);
              },
            });
      }
            else{
let spli  = form.elements["credit-name"].value.split(" ");
  $.ajax({
              url: "https://api.simplynoted.com/api/storefront/users/create-customer",
              method: "POST",
              data: {
                email: form.elements["credit-email"].value,
                firstName:spli[0],
                lastName:spli[1],
                customer_invite: {
        to: form.elements["credit-email"].value,
        from: "rick@simplynoted.com",
        subject: "Welcome to Simply noted",
        custom_message: "Welcome to Simply noted! We're thrilled to have you as part of our community of savvy shoppers, and we can't wait to enhance your shopping experience."
      }
              },
              success: function (customerData) {
localStorage.setItem("snCustomerId",customerData.result?.shopifyId)
localStorage.setItem("notCustomerId",customerData.result?.shopifyId)

if(customerData.result?.message){
  alert(customerData.result.message);
}
                else{
    $.ajax({
              url: mainUrl + "create-customer?customerId=" + customerData.result?.shopifyId,
              method: "POST",
              data: {
                paymentMethodId: paymentMethodId,
                email: form.elements["credit-email"].value,
                name: form.elements["credit-name"].value,
                address: {
                  line1: form.elements["credit-address"].value,
                  line2: form.elements["credit-apartment"].value,
                  city: form.elements["credit-city"].value,
                  state: form.elements["credit-state"].value,
                  country: form.elements["credit-country"].value                  
                },
              },
              success: function (customerData) {
                if (customerData.stripeCustomerId) {
                  $(".form-loader").fadeOut();
                  $(".loader-payemnt").addClass("loader-payemnt-active");
                  setTimeout(function () {
                      $(".loader-payemnt").removeClass(
                        "loader-payemnt-active"
                      );
           $.ajax({
                url: "https://api.simplynoted.com/stripe/customer-data?customerId=" + localStorage.getItem("notCustomerId"),
                method: "GET",
                success: function (respo) {
$(".pay-now").css("opcaity","1");      
$(".pay-now").text("SAVE");
$(".credit-card-form").hide();
$(".credit-card_input_fields").show();
$("input#saved_credit-card[disabled]+label").css("opcaity","1"); 
$("input#saved_credit-card[disabled]+label").css("pointer-events","auto"); 
$("#payment-form-add").hide();
$("#multiple-card-form").show();
                  $(".exsiting-cards").html(" ");
                  respo.payments.forEach(function (e, index) {
                    let payment = `<div class="card-element-filled"><div>
<input type="radio" id="id-${index}" name="payment" value="${e.paymentId}" checked> <label  for="id-${index}"></label>
</div><div><span>**** **** **** ${e.cardLast4Number}</span><span>${e.cardExpMonth} / ${e.cardExpYear}</span></div></div>`;
                    $(".exsiting-cards").prepend(payment);
                  });

                },
              });
                  }, 3500);
                }
              },
              error: function (customerError) {
                console.log("Customer Error:", customerError);
$(".error-update-card-0").show();
                $(".error-update-card-0").text("Error:",customerError.error.message);
              },
            });
                  
                }
              }
              });
            }
  
        
          }
        }).catch(function (error) {
          console.log("error", error)
        });
    })
});

$(".apply-discount").click(function(){
  const formData = new FormData();
  let customerIddfds = localStorage.getItem("notCustomerId");
 if($('body').hasClass("loggedin")){
   customerIddfds = localStorage.getItem("snCustomerId");
}
formData.append("code", $("#Discount").val());
formData.append("amount", $(".grand_total_price p").data("price"));
console.log($("#Discount").val());
if($("#Discount").val() == ""){
$('.show_error_mess').text("Discount field cannot be blank.");
        $(".order_summary_content_dis .show_error_mess").show();
}
 else if($("#Discount").val() == "" && $("body").hasClass("log-out")){
$('.show_error_mess').text("To apply a discount, please first add your card details.");
        $(".order_summary_content_dis .show_error_mess").show();
}
else{
 let totat = 0;
$(".fifth_block_middle_subtotal").each(function(){
  totat += $(this).data("price");
})
$.ajax({
    method: "GET",  // Change the HTTP method to POST
    dataType: 'json',
    contentType: "application/json; charset=UTF-8",
    url: "https://api.simplynoted.com/api/storefront/shopify/coupon-details?code="+$("#Discount").val()+"&amount="+totat+"&customerId="+customerIddfds,
    success: function (discountData) {
      //  $(".apply-discount").addClass("disabled")
      // $(".apply-discount").attr("disabled",true);
      //  $(".apply-discount").attr("disabled",true);
      if(discountData.result.discountedAmount >= 0){
          $('.order_summary_total p').text("$"+discountData.result.savingsAmount);
          $(".grand_total_price p").data("price",discountData.result.savingsAmount);
        $(".grand_total_price p").text("$"+discountData.result.savingsAmount);
          $('.discount_div').show();
          $('.discount_div p').text("-$"+discountData.result.discountedAmount);
$(".order_summary_plan.discount_div b").text($("#Discount").val());
$("#Discount").attr("data-type",discountData.result.value_type);
$("#Discount").attr("data-discounted-Amount",discountData.result.value);
      } else {
        $('.show_error_mess').text(discountData.result.message);
        $(".order_summary_content_dis .show_error_mess").show().delay(5000).fadeOut();
      }
      
      
    }
});
}



})